import { BitrixVue } from 'ui.vue';
/**
 * теперь этот файл/поток будет кодироваться в UTF-8
 */

BitrixVue.component('ResultBlockRow', {
	props: ['row'],
	template: `
			<div class="result-block__row">
					<div class="result-block__row-data">{{row.title + ' ' + row.value}}</div>
					<div class="result-block__row-price">{{row.price}}</div>
			</div>
`,
});
